import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { catchError } from 'rxjs/operators'
import { throwError } from 'rxjs'

@Component({
  selector: 'app-interceptor',
  templateUrl: './interceptor.component.html',
  styleUrls: ['./interceptor.component.scss']
})
export class InterceptorComponent implements OnInit {

  constructor(private _snackBar: MatSnackBar, private commonServ: CommonService
  ) { }

  ngOnInit(): void {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //   if (this.isValidRequestForInterceptor(request.url)) {
    let modifiedRequest;
    if (request.headers.get("skip")) {
      modifiedRequest = request.clone({
      });
    } else {
      console.log("sessionStorage" + sessionStorage.getItem("jwttoken"))
      modifiedRequest = request.clone({
        setHeaders: {
          "Authorization": "Bearer " + sessionStorage.getItem("jwttoken")
        }
      });
    }



    return next.handle(modifiedRequest).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        // console.log("error",error)

        if (error.status == 401) {
          // console.log("ty",error)
          let errorMessage = '';
          //   let config = new MatSnackBarConfig();
          //   config.duration = 5000;
          //   errorMessage = "Error Code : " + error.status + "  Message : " + error.error;
          //   this._snackBar.open('Error ocurred. Please try again.'+" Error code: "+error.status+ " Error message : " + error.statusText,"Close",config);
          //this.commonServ.doLogOut1();
          return throwError(errorMessage);
        } else {
          let errorMessage = '';
          let config = new MatSnackBarConfig();
          config.duration = 5000;
          if (error.error instanceof ErrorEvent) {
            errorMessage = error.error?.message;
          } else {
            errorMessage = "Error Code : " + error.error?.status + "  Message : " + error.error?.error;
          }
          if (error.error?.status != undefined) {
            this._snackBar.open('Error ocurred. Please try again.' + " Error code: " + error.error?.status + " Error message : " + error.error?.error, "Close", config);
          } else {
            this._snackBar.open('Technical error ocurred. Please try again.', "Close", config)
          }
          return throwError(errorMessage);
        }
      })

    )
      ;

  }

}
